import { SUBSCRIPTION_FORM_KEYS } from "utils/constants";
import BankAccount from "./BankAccount";
import Id from "./Id";
import Kbis from "./Kbis";
import SchoolCertificate from "./SchoolCertificate";
import SocialSecurityCertificate from "./SocialSecurityCertificate";

const generateProofForm = ({
  isTNS,
  acceptTeletransmission,
  isPayerOrganization,
  hasChildrenOver20,
}) => ({
  [SUBSCRIPTION_FORM_KEYS.PROOF.SOCIAL_SECURITY_CERTIFICATE]:
    acceptTeletransmission && SocialSecurityCertificate,
  [SUBSCRIPTION_FORM_KEYS.PROOF.ENROLLMENT_CERTIFICATE]:
    hasChildrenOver20 && SchoolCertificate,
  [SUBSCRIPTION_FORM_KEYS.PROOF.ID]: Id,
  [SUBSCRIPTION_FORM_KEYS.PROOF.BANK_ACCOUNT]: BankAccount,
  // KBIS - required when payer is an organization (autre payeur + switch organization)
  [SUBSCRIPTION_FORM_KEYS.PROOF.KBIS]: isPayerOrganization && Kbis,
});

export default generateProofForm;
